import { SCROLL_TO_DURATION, TRANSITION_DURATION } from './misc';
import { GET_RESULTS_EVENT } from './results';


var $ = require('jquery');
import './scrollto'; // jquery plugin needs to come after jquery


export const SHOW_QUESTIONS_EVENT = 'ge-assessments:questions:show';


/*
    this ended up being more of a jQuery-spaghetti solution than originally
    intended (but then who intends to write jQuery-spaghetti?); even such a
    basic set of behaviors and states starts to get hard to work with real
    quick, as this code illustrates; it'd be nice to try to re-write it using
    something like React et al
*/


function setup() {
    let $formOuter = $('.asmt-form-outer');
    resetQuestions($formOuter);
    $formOuter.children(':not(.questions-outer,.asmt-inside-header)').hide();
    $formOuter.find('.questions-page').hide().first()
        .slideDown(100, function() { $formOuter.scrollto(SCROLL_TO_DURATION); });
}


function resetQuestions($formOuter) {
    $formOuter.find('.questions-page input[type="radio"]').attr('checked', false);
    $formOuter.find('.questions-page .toggle-question-context')
        .removeClass('toggle-question-context-active asmt-brand-color');
    $formOuter.find('.questions-page .toggle-question-context').each(
        function(_, e) { toggleSeeContext($(e), true); }
    );
}


function toggleSeeContext($button, reset) {
    let $arrow = $button.find('.see-context-arrow');

    if (reset) {
        $arrow.removeClass('see-context-arrow-up').addClass('see-context-arrow-down');
        $button.next('.question-context-text').hide();
    } else {
        if ($arrow.hasClass('see-context-arrow-down')) {
            $arrow.removeClass('see-context-arrow-down').addClass('see-context-arrow-up');
        } else {
            $arrow.removeClass('see-context-arrow-up').addClass('see-context-arrow-down');
        }

        $button.next('.question-context-text').slideToggle(225);
    }
}


function collateAnswerData() {
    return $.map($('.asmt-container .question-container').toArray(), function(e) {
        let $e = $(e);
        return {
            question_number: $e.data('question-number'),
            selected_answer: $e
                .find('.answer-container input[type="radio"]:checked')
                .data('answer-number')
        };
    });
}


export function attachQuestionEvents() {
    let $document = $(document);
    let $body = $('body');

    // listen for the initial setup event
    $document.on(SHOW_QUESTIONS_EVENT, function() { setup(); });

    // toggle whether the explanation (aka 'context') buttons are active
    $body.on('change', '.answer-container input[type="radio"]', function() {
        let $radio = $(this);
        let $seeContextButton = $radio
            .closest('.question-container')
            .find('.toggle-question-context');
        $seeContextButton.addClass('toggle-question-context-active asmt-brand-color');
    });

    // explanation (aka 'context') show/hide
    $body.on('click', '.asmt-container .toggle-question-context-active', function() {
        toggleSeeContext($(this));
    });

    // 'next page' / 'get results' buttons
    $body.on('click', '.asmt-container button.next-page', function() {
        let $button = $(this);
        let $questionsPage = $button.closest('.questions-page');

        let $answerGroups = $questionsPage.find('.answer-container');
        let unanswered = $answerGroups.filter(
            (_, e) => !($(e).find('input:checked').length)
        ).length;

        if (unanswered) {
            return $button
                .closest('.questions-page')
                .find('.unanswered-questions-message')
                .show()
                .scrollto(SCROLL_TO_DURATION);
        }

        $body.find('.unanswered-questions-message').hide();

        if ($button.hasClass('get-results')) {
            $('.asmt-container .asmt-form-outer').hide();
            $document.trigger(GET_RESULTS_EVENT, { answers: collateAnswerData() });
        } else {
            $questionsPage
                .slideUp(TRANSITION_DURATION)
                .next('.questions-page')
                .slideDown(TRANSITION_DURATION)
                .parent().parent().scrollto(SCROLL_TO_DURATION);
        }
    });

    // 'previous page' buttons
    $body.on('click', '.asmt-container button.prev-page', function() {
        let $questionsPage = $(this).closest('.questions-page');
        $questionsPage
            .slideUp(TRANSITION_DURATION)
            .prev('.questions-page')
            .slideDown(TRANSITION_DURATION)
            .parent().parent().scrollto(SCROLL_TO_DURATION);
        $body.find('.unanswered-questions-message').hide();
    });
}



// WEBPACK FOOTER //
// ./src/questions.js